import {Dispatch} from "redux";
import {HIDE_NOTIFICATION, SHOW_LOADING, SHOW_NOTIFICATION} from "../action_types/notificationActionTypes";

const displayTime = 3000;
let timer: NodeJS.Timeout;

export function showLoading() {
    return (dispatch: Dispatch) => {
        if (timer) {
            clearInterval(timer);
        }

        dispatch({
            type: SHOW_LOADING,
        });
    };
}

export function showNotification(message: string, persistent = false) {
    return (dispatch: Dispatch) => {
        if (timer) {
            clearInterval(timer);
        }

        if (!persistent) {
            timer = setTimeout(() => hideNotification()(dispatch), displayTime);
        }
        dispatch({
            message,
            type: SHOW_NOTIFICATION,
        });
    };
}

export function hideNotification() {
    return (dispatch: Dispatch) => {
        if (timer) {
            clearInterval(timer);
        }

        dispatch({
            type: HIDE_NOTIFICATION,
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/notificationActions.ts